import 'react-app-polyfill/ie11';
import 'core-js/stable';
import React, { useContext, useCallback,useState } from 'react';
import { hooks } from "botframework-webchat-component";
import { AppContext } from "../util/appContext";
import Spinner from "./Spinner";
import Close from "../images/svg/Close.svg";
import StaticLabels from "../util/staticLabels.json";
import liveAgentStaticLabels from "../util/liveAgentStaticLabels.json";
import {setCookie, getCookie} from '../util/cookieActions';
import HeaderLogo_HBT from "../images/svgLatest/HeaderLogo_HBT.svg";
import Markdown from "markdown-to-jsx";
var classNames = require("classnames");

const MyLink = ({ children, ...props }) => {
  return (
    <a style={{ fontSize: "9px !important", textDecoration: 'underline' }} {...props}>
      {children}
    </a>
  );
};

function GreetHBTUser() {
  const timeFormat = formatAMPM(new Date());
  if (timeFormat.ampm === 'AM') {
    return StaticLabels[window.config.language].GoodMorning;
  } else {
    if (timeFormat.hour >= 4 && timeFormat.hour <= 7) {
      return StaticLabels[window.config.language].GoodEvening;
    }
    if (timeFormat.hour >= 1 && timeFormat.hour <= 4) {
      return StaticLabels[window.config.language].GoodAfternoon;
    }

    if (timeFormat.hour === 12) {
      return StaticLabels[window.config.language].GoodAfternoon;
    }

    if (timeFormat.hour > 7 && timeFormat.hour) {
      return StaticLabels[window.config.language].GoodEvening;
    }
  }
}

function formatAMPM(date) {
  var hours = date.getHours();
  // var minutes = date.getMinutes();
  var ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12;
  return { hour: hours, ampm: ampm };
}

const WelcomeCardHBT = ({ content, contentType, handleModalChange, contentPrivacy, handleMaximizeChange, handleCloseModalPopup }) => {
  const { useSendMessage, useSendEvent } = hooks;
  const context = useContext(AppContext);
  const sendMessage = useSendMessage();
  const sendEvent = useSendEvent();
  const [checkPrivacy1, setCheckPrivacy1] = useState(false);
  const [checkPrivacy2, setCheckPrivacy2] = useState(false);
  const isButtonDisabled = window.config.isChina && !(checkPrivacy1 && checkPrivacy2);
  const privacyCheckedClass = isButtonDisabled  ? window.config.language =="zh" || window.config.language =="zh-Hans" ?"privacyCheckedClass chinese":"privacyCheckedClass english" : "";
  var homeMenuoptions = classNames({
    customscrollbar : true,
    homeContainerButtonsHBT : true
  });
  const handleButtonClick = (selectedOption) => {
    let welcomecardBotDiv = document.getElementsByClassName('welcomecardBotDivHeight');
    if (welcomecardBotDiv.length > 0 ) {
        welcomecardBotDiv[0].style.height = 'auto';
    }
    
    context.setOptionSelected(true);
    context.setShowHeaderFooter(true);
    context.setShowSendBox(true);
    context.setEnableScroll(true);
    context.setHideStickyMenu(false);
    context.setMoreOptionsClick(false);
    setCookie(window.config.businessUnit + '-Conversation',true);
    sendMessage(selectedOption);
  }

  const handleHBTNoThanks = useCallback(event => {
    sendEvent('SalesPagesNoThanks', { clickedNoThanks : true });
    handleCloseModalPopup();
    handleMaximizeChange();
    },
    [sendEvent, handleCloseModalPopup, handleMaximizeChange]
  );

  const handleHBTCrossIconClick = useCallback(event => {
    if(window.config.isSalesPage) {
      sendEvent('SalesPagesNoThanks', { clickedNoThanks : false });
    }
    handleCloseModalPopup();
    handleMaximizeChange();
    },
    [sendEvent, handleCloseModalPopup, handleMaximizeChange]
  );


  var headerClass = classNames({
    headerMax: true,
    header: true
  });
const capitalizeFirstLetter = (string) => {
    return string
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  function AMPMFormat(date) {
  var hours = date.getHours();
  var ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; 
  return { hour: hours, ampm: ampm };
}
function GreetUser(userLanguage) {
  const timeFormat = AMPMFormat(new Date());
  if (timeFormat.ampm === "AM") {
    return userLanguage
      ? capitalizeFirstLetter(StaticLabels[userLanguage.toLowerCase()].GoodMorning)
      : capitalizeFirstLetter("good morning");
  } else {
    if (timeFormat.hour >= 4 && timeFormat.hour <= 7) {
      return userLanguage
        ? capitalizeFirstLetter(StaticLabels[userLanguage.toLowerCase()].GoodEvening)
        : capitalizeFirstLetter("good evening");
    }
    if (timeFormat.hour >= 1 && timeFormat.hour <= 4) {
      return userLanguage
        ? capitalizeFirstLetter(StaticLabels[userLanguage.toLowerCase()].GoodAfternoon)
        : capitalizeFirstLetter("good afternoon");
    }

    if (timeFormat.hour === 12) {
      return userLanguage
        ? capitalizeFirstLetter(StaticLabels[userLanguage.toLowerCase()].GoodAfternoon)
        : capitalizeFirstLetter("good afternoon");
    }

    if (timeFormat.hour > 7 && timeFormat.hour) {
      return userLanguage
        ? capitalizeFirstLetter(StaticLabels[userLanguage.toLowerCase()].GoodEvening)
        : capitalizeFirstLetter("good evening");
    }
  }
}


  const liveAgentUnavailableMsg = () => {
    const lacUnavailable = content.buttons.some((buttonText, index) => (buttonText.toLowerCase() === liveAgentStaticLabels[window.config.language].LiveAgentUnavailable));
    if(lacUnavailable) {
        return (
          <div className='HBTLiveagentTextAlign'>
            {content.lacOperationalHoursMsg && <p className='HBTLiveagentFont'>{content.lacOperationalHoursMsg}</p>}
            {content.lacHolidaysMsg && <p className='HBTLiveagentFont'>{content.lacHolidaysMsg}</p>}
          </div>
        )
    }
  }

  const languageEnabled = window.config.language === 'en' || window.config.language === 'de' || window.config.language === 'fr' || window.config.language === 'it' || window.config.language === 'es' || window.config.language === 'nl' || window.config.language === 'fr-ca' || window.config.language === 'zh'

  return (
    context.showSpinnerWheel === false ?
      !getCookie(window.config.businessUnit + '-Conversation') &&
      (context.optionSelected === false &&
         <div style={{padding : '0px', marginTop : '-13px'}}>
          <div className={headerClass}>
            <div className="ask-ellie">
              <img
                className="launcherIconAvatar"
                alt="miniAvatar"
                src={HeaderLogo_HBT}
              /> 
              <h4 style={{fontWeight : '600'}}>Honeywell Assist</h4>
            </div>
            <ul>
              <li style={{cursor: 'pointer'}}>
              <img alt="Close"   title="Close Bot" src={Close} onClick={handleHBTCrossIconClick}></img>
              </li>
            </ul>
        </div>
        <div className="homeContainer homeContainerBA">
          <div className="homeContainerFixed">
              <div className="botTextBox conversationTextBox conversationTextBoxWelcomeMessage">
                <div className="conv-text welcomeMessage">
                  <p>{content.text.includes("[GreetDCAUser]") ? content.text.replace("[GreetDCAUser]", `${GreetUser(window.config.language)} `) : content.text}</p>
                </div>
              </div>
              {window.config.isChina? <><p className="privacyPara privacyParaChina"><label><input type="checkbox" name="chinaCheckPrivacy1"  checked={checkPrivacy1} onChange={() => setCheckPrivacy1(prev => !prev)} /></label>{<Markdown
                options={{
                  overrides: {
                    forceBlock: true,
                    forceInline: false,
                    a: {
                      component: MyLink,
                      target: "_blank",
                      props: {
                        className: "markdown-link",
                        target: "_blank"
                      }
                    }
                  }
                }}
              >{window.config.language ? StaticLabels[window.config.language].privacyBATextCh : StaticLabels["en"].privacyBATextCh}</Markdown>}
              </p><p className="privacyPara privacyParaChina"><label><input type="checkbox" name="chinaCheckPrivacy2" checked={checkPrivacy2} onChange={() => setCheckPrivacy2(prev => !prev)}/></label>{<Markdown
                options={{
                  overrides: {
                    forceBlock: true,
                    forceInline: false,
                    a: {
                      component: MyLink,
                      target: "_blank",
                      props: {
                        className: "markdown-link",
                        target: "_blank"
                      }
                    }
                  }
                }}
              >{window.config.language ? StaticLabels[window.config.language].privacyBAText2Ch : StaticLabels["en"].privacyBAText2Ch}</Markdown>}
              </p></> :
              <p className="privacyPara">{<Markdown
                options={{
                  overrides: {
                    forceBlock: true,
                    forceInline: false,
                    a: {
                      component: MyLink,
                      target: "_blank",
                      props: {
                        className: "markdown-link",
                        target: "_blank"
                      }
                    }
                  }
                }}
              >{window.config.language ? StaticLabels[window.config.language].privacyBAText : StaticLabels["en"].privacyBAText}</Markdown>}
              </p>
              }
                {content.salesMessage && <div style= {{marginBottom : '0.3rem'}} className="botTextBox conversationTextBox conversationTextBoxWelcomeMessage">  
                <div className="conv-text">
                   <p className='HBTLiveagentMargin'>{content.salesMessage}</p> 
                </div>
                </div>}
          </div>
           
             {languageEnabled ? 
            <div className={homeMenuoptions}>
              {content.buttons.map((buttonText, index) => (
                buttonText.toLowerCase() === liveAgentStaticLabels[window.config.language].CloseChat.toLowerCase() ?
                <button key={index} className="btn-secondary WelcomeButton"  onClick={handleHBTNoThanks}>{buttonText} </button>
                :
                window.config.isChina && buttonText.toLowerCase() != liveAgentStaticLabels[window.config.language].LiveAgentUnavailable.toLowerCase() && isButtonDisabled && privacyCheckedClass ?
                  <div class="chinaGrid"><button key={index} className={`btn-secondary WelcomeButton ${buttonText.toLowerCase() === liveAgentStaticLabels[window.config.language].LiveAgentUnavailable.toLowerCase()?'LiveAgentUnavailable':''} ${privacyCheckedClass}`} disabled={(isButtonDisabled && privacyCheckedClass) ? true : false} onClick={() => handleButtonClick(buttonText)}>{buttonText} </button><span className={`statementcontinue ${privacyCheckedClass}`}>{window.config.language ? StaticLabels[window.config.language].privacyBATextTooltip:StaticLabels["en"].privacyBATextTooltip}</span></div>:<button key={index} className={`btn-secondary WelcomeButton ${buttonText.toLowerCase() === liveAgentStaticLabels[window.config.language].LiveAgentUnavailable.toLowerCase()?'LiveAgentUnavailable':''}`} disabled={buttonText.toLowerCase() === liveAgentStaticLabels[window.config.language].LiveAgentUnavailable.toLowerCase() ? true : false} onClick={() => handleButtonClick(buttonText)}>{buttonText} </button> 
                ))}
            </div> :
            <div className={homeMenuoptions}>
            {content.buttons.map((buttonText, index) => (
              <>
                {
                  window.config.isChina && buttonText.toLowerCase() != liveAgentStaticLabels[window.config.language].LiveAgentUnavailable.toLowerCase() && isButtonDisabled && privacyCheckedClass ? <div class="chinaGrid"><button key={index} className={`btn-secondary WelcomeButton ${buttonText.toLowerCase() === liveAgentStaticLabels[window.config.language].LiveAgentUnavailable.toLowerCase()?'LiveAgentUnavailable':''} ${privacyCheckedClass}`} disabled={(buttonText.toLowerCase() === liveAgentStaticLabels[window.config.language].LiveAgentUnavailable.toLowerCase()) || (isButtonDisabled && privacyCheckedClass) ? true : false} onClick={() => handleButtonClick(buttonText)}>{buttonText}</button><span className={`statementcontinue ${privacyCheckedClass}`}>{window.config.language ? StaticLabels[window.config.language].privacyBATextTooltip:StaticLabels["en"].privacyBATextTooltip}</span></div> : <button key={index} className={`btn-secondary WelcomeButton ${buttonText.toLowerCase() === liveAgentStaticLabels[window.config.language].LiveAgentUnavailable.toLowerCase()?'LiveAgentUnavailable':''}`} disabled={buttonText.toLowerCase() === liveAgentStaticLabels[window.config.language].LiveAgentUnavailable.toLowerCase()?true:false} onClick={() => handleButtonClick(buttonText)}>{buttonText}</button>
                }
              </>))
              }
          </div>}
          
          {liveAgentUnavailableMsg()}
            <div>  
          </div>
        </div>
        </div>
      
      ) : (
      <Spinner
          isMaximised={true}
          showSpinner={true}
          handleModalChange={handleModalChange}
        />
      )
  )
}

export default WelcomeCardHBT;